import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { DocumentUpload } from './DocumentUpload'
import { DocumentUploadProps } from './types'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

const DocumentUploadWrapper: React.FC<DocumentUploadProps> = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <DocumentUpload {...props} />
    </QueryClientProvider>
  )
}

export default DocumentUploadWrapper
